
export type TeamType = typeof TeamType[keyof typeof TeamType];


export const TeamType = {
  Default: 'Default',
  SignatureVerification: 'SignatureVerification',
} as const;
